import React from 'react';
import './Skeleton.css';

interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  className?: string;
}

export function Skeleton({ width = '100%', height = '16px', borderRadius = '6px', className = '' }: SkeletonProps) {
  return (
    <div
      className={`skeleton ${className}`.trim()}
      style={{ width, height, borderRadius }}
    />
  );
}

export function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-card-header">
        <Skeleton width="60%" height="18px" />
        <Skeleton width="50px" height="20px" borderRadius="12px" />
      </div>
      <Skeleton width="90%" height="14px" />
      <Skeleton width="70%" height="14px" />
      <div className="skeleton-card-footer">
        <Skeleton width="80px" height="12px" />
        <Skeleton width="60px" height="12px" />
      </div>
    </div>
  );
}

export function SkeletonCodeBlock() {
  return (
    <div className="skeleton-code-block">
      <Skeleton width="100%" height="14px" />
      <Skeleton width="85%" height="14px" />
      <Skeleton width="92%" height="14px" />
      <Skeleton width="60%" height="14px" />
      <Skeleton width="78%" height="14px" />
      <Skeleton width="100%" height="14px" />
      <Skeleton width="45%" height="14px" />
    </div>
  );
}
